/** Ad display mode for the sticky footer.
 *  - 'off'        : no ads, copyright only
 *  - 'bottom-2'   : one ad on each side (2 total) at all sizes
 *  - 'bottom-4'   : two ads on each side (4 total) at all sizes
 *  - 'responsive' : 4 ads on desktop, 2 on tablet (≤1080px), 0 on phone (≤480px)
 */
export type AdMode = 'off' | 'bottom-2' | 'bottom-4' | 'responsive';

export const AD_MODE: AdMode = 'responsive';
